import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TipoCliente } from '../../../comun/model/salud.model';
import urls from '../../../../assets/config/urls.json';
import { CaModalOverlayService, ModalConfig } from '@global-front-components/ui/modal-overlay';
import { ModalInformacionImagenComponent } from '../../../comun/components/modal-informacion-imagen/modal-informacion-imagen.component';
import { CaButtonComponent } from '@global-front-components/ui/button';

@Component({
	selector: 'app-informacion-tarificacion',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		CaButtonComponent
	],
	templateUrl: './informacion-tarificacion.component.html',
	styleUrls: ['./informacion-tarificacion.component.scss']
})
export class InformacionTarificacionComponent implements OnInit {
	@Input() esDental: boolean = false;
	@Input() tipoCliente: TipoCliente;
	@Input() codCanal: string;
	@Input() mostrarInfoSeniorYNormal: boolean = false;
	labelInfoCampania: string;
	urlInfoCampania: string;
	urlCuadro: string;

	@Output() verAlternativaSenior = new EventEmitter<void>();
	@Output() verTodosProductos = new EventEmitter<void>();

	constructor(
		private _translateService: TranslateService,
		private _modalService: CaModalOverlayService
	) {

	}

	ngOnInit(): void {
		this.rellenarCamposInfoCampania();
		this.urlCuadro = (urls as any).CUADRO_MEDICO || '';
	}

	private rellenarCamposInfoCampania(): void {
		this.codCanal = this.codCanal === 'AyC' ? 'AC' : this.codCanal;
		const prefijoDental = this.esDental ? 'DU_' : 'SU_';
		const tipo = this.tipoCliente?.idTipoCliente === 0 ? 'PAR_' : 'PYM_';
		const claveInfoCampania = `SALUD.RECOMENDADOR.LABEL_OPCION.${this.codCanal}_${prefijoDental}${tipo}INFORMACION_CAMPANIA`;
		this.labelInfoCampania = this._translateService.instant(claveInfoCampania);

		const claveUrl = `${this.codCanal}_${prefijoDental}${tipo}INFORMACION_CAMPANIA_URL`;
		this.urlInfoCampania = (urls as any).INFO_CAMPANIAS[claveUrl] || '';
	}

	onVerTodosProductos() {
		this.verTodosProductos.emit();
	}
	
	onVerAlternativaSenior() {
		this.verAlternativaSenior.emit();
	}

	abrirModalInfoCampania() {
		this._translateService.get('SALUD.RECOMENDADOR.LABEL_OPCION.CONSULTAR_INFORMACION')
			.subscribe(title => {
				const modalConfig: ModalConfig = {
					windowDrag: true,
					backdropClick: true,
					isBodyScrollable: true,
					closable: true,
					minimizable: false,
					title,
					data: { urlImagen: this.urlInfoCampania } 
				};
				this._modalService.open(ModalInformacionImagenComponent, modalConfig);
			});
	}
}
